import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import {
  AUTH_HEADER,
  SECURE_AUTH_TOKEN_KEY,
  SECURE_BASE_URL_KEY,
} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { FetchOlaMapsAutoCompleteLocationType } from "../../../domain/models/ola-maps/fetch-ola-maps-auto-complete-location";
import { FetchOlaMapsAutoCompleteLocation } from "../../../domain/useages/ola-maps/fetch-ola-maps-auto-complete-location";
import { RemoteFetchOlaMapsAutoCompleteLocation } from "../../../data/usecases/ola-maps/remote-fetch-ola-maps-auto-complete-location";

export interface FetchOlaMapsAutoCompleteLocationInterface {
    FetchOlaMapsAutoCompleteLocation: FetchOlaMapsAutoCompleteLocationType;
    FetchOlMapsAutoCompleteLocationState: FetchState;
    fetchOlaMapsAutoCompleteLocation: Function;
}

const initialStates = {
  FetchOlaMapsAutoCompleteLocation: {} as FetchOlaMapsAutoCompleteLocationType,
  FetchOlMapsAutoCompleteLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchOlaMapsAutoCompleteLocationSlice: StateCreator<
  FetchOlaMapsAutoCompleteLocationInterface
> = (set) => ({
  ...initialStates,
  fetchOlaMapsAutoCompleteLocation: async (
    params: FetchOlaMapsAutoCompleteLocation.Params
  ) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchOlaMapsAutoCompleteLocation =
      new RemoteFetchOlaMapsAutoCompleteLocation(
        `${BASE_URL}${Endpoints.FETCH_OLA_MAPS_AUTO_COMPLETE_LOCATION}`,

        axiosHttpClient
      );

    set(() => ({ FetchOlMapsAutoCompleteLocationState: FetchState.LOADING }));
    let result = await remoteFetchOlaMapsAutoCompleteLocation.fetch(params);
       set(() => ({
         FetchOlaMapsAutoCompleteLocation: result,
         FetchOlMapsAutoCompleteLocationState: FetchState.SUCCESS,
       }));
  },
});
